<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
      default: "Mostrar más tareas...",
    },
  },
  methods: {
    loadMore() {
      this.$emit("loadMore");
    },
  },
};
</script>

<template>
  <div class="btn-more" @click="loadMore">
    <i class="fas fa-spinner fa-spin" v-if="loading"></i>
    <span v-else> {{ text }} </span>
  </div>
</template>

<style scoped>
.btn-more {
  display: inline-block;
  max-height: 50px;
  min-width: 200px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: relative;
  cursor: pointer;
  padding: 0.5rem 0;
  border-radius: 0 0 12px 12px;
  background-color: transparent;

  &:hover span {
    text-decoration: underline;
  }
}
</style>
